import React, { FunctionComponent, useState } from 'react';
import { DefaultButton, Dialog, DialogFooter, SharedColors, Stack, Text } from '@fluentui/react';
import { deleteGroupRole, GroupRole } from '../../../services/groupRoles.service';
import { SalusPrimaryButton } from '../../shared/SalusPrimaryButton';

interface DeleteGroupRoleDialogProps {
  showDeleteGroupRoleDialog: boolean;
  setShowDeleteGroupRoleDialog: React.Dispatch<React.SetStateAction<boolean>>;
  activeGroupRole: GroupRole;
}

export const DeleteGroupRoleDialog: FunctionComponent<DeleteGroupRoleDialogProps> = (props): JSX.Element => {
  const [addGroupRoleErrorMessage, setAddGroupRoleErrorMessage] = useState('');
  const onRemoveGroup = () => {
    if (props.activeGroupRole?.id) {
      deleteGroupRole(props.activeGroupRole)
        .then(() => {
          props.setShowDeleteGroupRoleDialog(false);
        })
        .catch(() => {
          setAddGroupRoleErrorMessage(
            'Encountered a problem deleting this GroupRole. Try again, then contact support.'
          );
        });
    }
  };

  return (
    <Dialog
      isBlocking={false}
      hidden={!props.showDeleteGroupRoleDialog}
      dialogContentProps={{
        title: `Delete ${props.activeGroupRole.groupName}'s ${props.activeGroupRole.role} role?`,
        subText: `Are you sure you want to remove the '${props.activeGroupRole.role}' role for all users in the group '${props.activeGroupRole.groupName}'?`
      }}
      modalProps={{
        overlay: {
          isDarkThemed: true
        }
      }}
    >
      <DialogFooter>
        <SalusPrimaryButton onClick={onRemoveGroup} text="Remove" />
        <DefaultButton onClick={(): void => props.setShowDeleteGroupRoleDialog(false)} text="Cancel" />
        {addGroupRoleErrorMessage && (
          <Stack>
            <Text style={{ textAlign: 'center', marginTop: 20, color: SharedColors.red20 }}>
              {addGroupRoleErrorMessage}
            </Text>
          </Stack>
        )}
      </DialogFooter>
    </Dialog>
  );
};
